import React, {useState, Fragment } from "react";
import { Pressable, View, Text, StyleSheet } from "react-native";
import { FONT, FORNAX_VERSION } from "value/staticValues";

import { ReactComponent as MenuCloseImg } from '../../../img/ico-side-bar-menu-side-bar-closed.svg';
import { SideBarItemData, SideBarMenus } from "./sideBarData";
import SideBarExpandedMenuItem from "./sideBarExpandedMenuItem";


interface SideBarExpandedMenuProps {
    toggleSizeCb: Function,
}

function SideBarExpandedMenu(props:SideBarExpandedMenuProps) {
    const [toggleButtonContainerStyle, setToggleButtonContainerStyle] = useState(style.menuBar);
    const [activeItem, setActiveItem] = useState(0);

    function menuItemActive(id:number) {
        setActiveItem(id);
    }

    return (
        <Fragment>
            <View>
                <Pressable
                    style={toggleButtonContainerStyle}
                    onPress={()=>props.toggleSizeCb(false)}
                    onHoverOut={()=>{setToggleButtonContainerStyle({...style.menuBar, backgroundColor:"#212943"});}}
                    onHoverIn={()=>{setToggleButtonContainerStyle({...style.menuBar, backgroundColor:"#323ba6"});}}
                >
                    <MenuCloseImg />
                </Pressable>
                {
                    SideBarMenus.map((menu:SideBarItemData, index) => {
                        return (
                            <SideBarExpandedMenuItem key={index} item={menu} menuItemActiveCb={menuItemActive} activeItemIdForOpenSubItem={activeItem}/>
                        )
                    })
                }
            </View>
            <View style={{alignItems:"center", justifyContent:"center", alignSelf:"center", backgroundColor:"#1c2237", borderRadius:12, marginBottom:40, paddingLeft:30, paddingRight:30, paddingTop:5, paddingBottom:5, marginTop:"auto"}}>
                <Text style={{ color:"#9199b3", fontSize:12, fontFamily:FONT.REGULAR }}>{`FornaX Version ${FORNAX_VERSION}`}</Text>
            </View>
        </Fragment>
    );
}


const style = StyleSheet.create({
    menuBar:{
        height: 50,
        paddingRight: 20,
        alignItems: "flex-end",
        justifyContent: "center",
        backgroundColor: "#212943",
        zIndex:8,
    }
})


export default SideBarExpandedMenu;